import { BulkImportType } from '../formSteps/FileSelection/hooks';

const BulkDRMImportTypeOptions = [
  BulkImportType.DATA_VENDOR,
  BulkImportType.DATASET,
  BulkImportType.CONTACT,
];

export function isDRMEntityBulkImport(bulkImportType: BulkImportType): boolean {
  return BulkDRMImportTypeOptions.includes(bulkImportType);
}
